module.exports = __webpack_public_path__ + "img/banner_info_carrossel.c484ffd1.jpg";